import React, { useEffect, useState } from "react";
import leftArrow from "../../assets/arrow-left-one.png";
import rightArrow from "../../assets/arrow-right-one.png";
import Products from "../../components/Products/Products";
import { Link } from "react-router-dom";
import ProductDiscription from "../../screens/ProductDiscription/ProductDiscription";
// import { Link } from "react-router-dom";

const ProductCarousel = ({ productsData, title }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [numVisibleProducts, setNumVisibleProducts] = useState(1);

  const handleResize = () => {
    const containerWidth =
      document.getElementById("product-container").offsetWidth;
    const productWidth = 250;
    const maxVisibleProducts = Math.floor(containerWidth / productWidth);

    if (window.innerWidth < 626) {
      setNumVisibleProducts(3);
    } else if (window.innerWidth < 1008) {
      setNumVisibleProducts(4);
    } else {
      setNumVisibleProducts(maxVisibleProducts);
    }
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + numVisibleProducts >= productsData.length
        ? 0
        : prevIndex + numVisibleProducts
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0
        ? productsData.length - numVisibleProducts
        : prevIndex - numVisibleProducts
    );
  };

  useEffect(() => {
    const containerWidth =
      document.getElementById("product-container").offsetWidth;
    const productWidth = 250;
    const maxVisibleProducts = Math.floor(containerWidth / productWidth);
    if (window.innerWidth < 626) {
      setNumVisibleProducts(3);
    } else if (window.innerWidth < 1008) {
      setNumVisibleProducts(4);
    } else {
      setNumVisibleProducts(maxVisibleProducts);
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ marginLeft: "2%", fontSize: "1.4rem", color: "#3b4351" }}>
          {title}
        </h2>
        <div
          style={{
            display: "flex",
            marginTop: "2%",
            marginRight: "8%",
            justifyContent: "space-between",
          }}
        >
          <img
            src={leftArrow}
            alt=""
            onClick={handlePrevious}
            style={{ cursor: "pointer", height: "20px" }}
          />
          <img
            src={rightArrow}
            alt=""
            onClick={handleNext}
            style={{ cursor: "pointer", height: "20px", marginLeft: "40%" }}
          />
        </div>
      </div>

      <div
        id="product-container"
        style={{
          display: "flex",
          alignItems: "center",
          overflowX: "hidden",
          width: "100%",
          gap: "8px",
          marginRight: "2%",
        }}
      >
        {productsData
          .slice(currentIndex, currentIndex + numVisibleProducts)
          .map((product, index) => (
            <Link
              to={`/product-discription/${product?.name}`}
              state={product}
              id="product-link"
              style={{ width: "100%", textDecoration: 'none' }}
            >
              <Products
                key={index}
                imageSrc={product.imageSrc}
                name={product.name}
                description={product.description}
                packSize={product.packSize}
                price={product.price}
              />
            </Link>
          ))}
      </div>
    </div>
  );
};

export default ProductCarousel;
